import { Stack, Typography, Button } from "@mui/material";
import { useContext, useState } from "react";
import ClienteService from "services/cliente";
import ApiContext from "api";
import TechnicianImage from "assets/illustrations/technician.png";
import { useHistory } from "react-router-dom";
import { moneyFormat } from "utils/Masks/Masks";
import { isFreeServicePrice } from "utils/servicePrice";
import CondominioService from "services/condominio";
import { AVAILABLE_CREDIT_CARD_COD } from "constants/available-credit-card-cod-motivo";
import { ConfirmationServiceItem } from "./ConfirmationServiceItem";

const FREE_SERVICE_MESSAGE = "Este serviço não tem custo.";

export default function ConfirmationService({
    data,
    service,
    serviceConfirmed,
}) {
  const [occurrence, setOccurrence] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(""); // boleto | cartao
  const [isLoading, setIsLoading] = useState(false);

    const { ConsigazApi } = useContext(ApiContext);

    const router = useHistory();

  const serviceTotal =
    data.hasMeter === "YES" ? 0 : service && service["vl-servico"];
  const occurrenceTotal = occurrence && occurrence["v-vl-servico"];
  const isFreeService =
    isFreeServicePrice(serviceTotal) || isFreeServicePrice(occurrenceTotal);

  const findLastDeliveryLocal = (locals) => {
    let maiorEntrega = "";
    let maiorNumero = -1;

        locals.forEach((local) => {
          const numero = parseInt(local.replace(/\D/g, ""), 10);

          if (numero > maiorNumero) {
            maiorNumero = numero;
            maiorEntrega = local;
          }
        });

    return maiorEntrega;
  };

  const generateOrder = async () => {
    const { CPFCNPJ, email, ClienteEntrRetorno } = ClienteService.localEntrega;

    setIsLoading(true);

    let localEntrega;

    if (ClienteEntrRetorno?.length === 1) {
      localEntrega = ClienteEntrRetorno[0]["local-entrega"];

      CondominioService.selected = ClienteEntrRetorno[0];
    } else {
      const locals = ClienteEntrRetorno.map((item) => item["local-entrega"]);
      localEntrega = findLastDeliveryLocal(locals);

      const endereco = ClienteEntrRetorno.filter(
        (item) => item["local-entrega"] === localEntrega
      );

      CondominioService.selected = endereco[0];
    }

    await ConsigazApi.geraOcorrencia(
      "",
      data.hasMeter === "YES" ? "Religue" : "Instalacao",
      data.hasMeter === "YES" ? 0 : service["vl-servico"],
      data.hasMeter === "YES" ? 0 : service["cod-motivo"],
      data.hasMeter === "YES" ? 0 : service["nr-acordo-comercial"],
      CPFCNPJ,
      localEntrega,
      {
        email,
        howWillAccess:
          data.hasDoorman === "NO" && data.enterQuestion === "others"
            ? data.othersAccess
            : "",
        portariaEletronica: data.hasDoorman,
        contatoAcesso:
          data.hasDoorman === "NO" && data.enterQuestion === "anotherPerson"
            ? data.name
            : "",
        contatoFone:
          data.hasDoorman === "NO" && data.enterQuestion === "anotherPerson"
            ? data.phone
            : "",
        moradorNoLocal: data.enterQuestion === "me" ? "YES" : "NO",
        ...(!isFreeService && { paymentMethod: paymentMethod || "boleto" }),
      }
    )
      .then(({ Ocorrencia }) => {
        if (Ocorrencia.length) {
          setOccurrence(Ocorrencia[0]);
          serviceConfirmed(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Stack p={" 0px 32px 32px 32px"}>
        <Stack direction={"row"} alignItems={"center"} mb={"18px"}>
          <Typography fontSize={"25px"} fontWeight={700} fontStyle={"italic"}>
            {occurrence ? "Serviço contratado!" : "Confirme a contratação"}
          </Typography>
        </Stack>
        <Typography
          fontSize={"14px"}
          fontWeight={500}
          color="#636363"
          align="justify"
          lineHeight={"100%"}
        >
          {occurrence
            ? "Anote os protocolos:"
            : "Você está prestes a contratar o serviço abaixo. Confirma a contratação?"}
        </Typography>
        <Stack
          alignContent={"center"}
          alignItems={"center"}
          mt={"57px"}
          gap={2}
        >
          <img
            src={TechnicianImage}
            alt="Serviço de religue"
            style={{
              width: "129px",
              height: "129px",
            }}
          />

          {occurrence && occurrence.linkPagtoMP && !isFreeService ? (
            <ConfirmationServiceItem
              service={service}
              occurrence={occurrence}
            />
          ) : (
            <Stack
              border={"1px solid #01C4FE"}
              p={"16px 40px"}
              mt={"8px"}
              width={"100%"}
              maxWidth={"500px"}
            >
              <Typography fontSize={"20px"} fontWeight={700}>
                {data.hasMeter === "YES" ? "Religue" : service.descricao}
              </Typography>
              {isFreeService ? (
                <Typography fontSize={"14px"} fontWeight={500}>
                  {FREE_SERVICE_MESSAGE}
                </Typography>
              ) : (
                <Typography fontSize={"14px"} fontWeight={500}>
                  {occurrence ? "" : "Valor total: "}
                  {occurrence
                    ? moneyFormat(occurrence["v-vl-servico"]) === "--"
                      ? "R$ 0,00"
                      : moneyFormat(occurrence["v-vl-servico"])
                    : data.hasMeter === "YES"
                    ? "R$ 0,00"
                    : moneyFormat(service["vl-servico"])}
                </Typography>
              )}
              {occurrence && (
                <Stack>
                  <Typography fontSize={"14px"} fontWeight={500}>
                    Protocolo:
                  </Typography>{" "}
                  <Typography fontSize={"20px"} fontWeight={700}>
                    {occurrence["v-nr-ocorrencia"]}
                  </Typography>
                  {!isFreeService && (
                    <Typography fontSize={"14px"} fontWeight={500}>
                      O boleto será enviado para o email cadastrado após a
                      execução do serviço.
                    </Typography>
                  )}
                </Stack>
              )}
            </Stack>
          )}

          {!occurrence &&
          !isFreeService &&
          service &&
          AVAILABLE_CREDIT_CARD_COD.includes(service["cod-motivo"]) ? (
            <Stack
              key={paymentMethod}
              width={"100%"}
              justifyContent={"center"}
              display={"flex"}
              alignItems={"center"}
            >
              <label>
                <input
                  type="checkbox"
                  className={paymentMethod === "cartao" ? "checked" : ""}
                  onClick={() => setPaymentMethod("cartao")}
                />
                <span
                  style={{
                    fontWeight: 700,
                  }}
                >
                  Cartão de Crédito (Link de Pagamento)
                </span>
              </label>

              <label>
                <input
                  type="checkbox"
                  className={paymentMethod === "boleto" ? "checked" : ""}
                  onClick={() => setPaymentMethod("boleto")}
                />
                <span
                  style={{
                    fontWeight: 700,
                  }}
                >
                  Boleto com prazo de pagamento{" "}
                  {service["cod-cond-pag"]
                    ? `de ${service["cod-cond-pag"]}`
                    : ``}
                </span>
              </label>

              {!paymentMethod ? null : (
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    gap: "4px",
                    marginTop: "24px",
                    width: "100%",
                  }}
                >
                  <span style={{ fontWeight: 700, fontSize: 16 }}>Prazos</span>
                  {paymentMethod === "boleto" && (
                    <span style={{ fontWeight: 600 }}>
                      Prazo para pagamento é de{" "}
                      {service["cod-cond-pag"]
                        ? `${service["cod-cond-pag"]}`
                        : ``}
                    </span>
                  )}
                  <span style={{ fontWeight: 600 }}>
                    O serviço solicitado será efetuado até 3 dias úteis
                    {paymentMethod === "boleto"
                      ? "."
                      : " após a confirmação do pagamento, e o prazo de atendimento começará ser contado a partir da data do pagamento."}
                  </span>
                </div>
              )}
            </Stack>
          ) : null}
        </Stack>
      </Stack>
      <Stack
        height={"135px"}
        bgcolor={"#053462"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Button
          variant="contained"
          color="secondary"
          sx={{
            color: "#fff",
            height: "45px",
            width: "358px",
            borderRadius: "36px",
          }}
          loading={isLoading}
          onClick={() => {
            if (occurrence) {
              return router.push("/save-time");
            }
            generateOrder();
          }}
        >
          {occurrence ? "OK" : "CONFIRMAR CONTRATAÇÃO"}
        </Button>
      </Stack>
    </>
  );
}
